import { theme } from '@chakra-ui/theme';

const App = {
    baseStyle: {
        container: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: 'white',
            minWidth: '320px',
        },
        headerWrapper: {
            position: 'sticky',
            top: 0,
            zIndex: theme.zIndices.sticky,
        },
    },
    parts: ['container'],
};

export default App;
